import {useEffect, useState} from "react";
import Editor from 'react-medium-editor';
import globalVars from "../utils/globalVars";

export default function MediumEditorSubcomponent(props) {
    const [myKey, setMyKey] = useState(props.mykey)
    const [expectedtext, setExpectedtext] = useState(props.expectedtext)
    const [currenttext, setCurrenttext] = useState('')
    const [backgroundColor, setBackgroundColor] = useState('white')
    const [borderColor, setBorderColor] = useState('white')
    const [ok, setOk] = useState(false)

    useEffect(() => {
        var isCurrentTextOk = false;
        isCurrentTextOk = expectedtext.split('|').map((e) => {
            return e.trim()
        }).includes(currenttext.trim());
        // setBackgroundColor(props.showFeedback ? ((isCurrentTextOk) ? '#eff' : '#fef') : 'inherit');
        setBackgroundColor(props.showFeedback ? ((isCurrentTextOk) ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk) : 'inherit');
        // setBorderColor(props.showFeedback ? ((isCurrentTextOk) ? '#3ff' : '#f3f') : 'black');
        setBorderColor(props.showFeedback ? ((isCurrentTextOk) ? globalVars.feedbackMode.borderColor.ok : globalVars.feedbackMode.borderColor.notOk) : 'black');
        setOk(isCurrentTextOk);
    }, [currenttext, props.showFeedback]);

    useEffect(() => {
        // setBackgroundColor(props.showFeedback ? ((ok) ? '#eff' : '#fef') : 'inherit');
        setBackgroundColor(props.showFeedback ? ((ok) ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk) : 'inherit');
        // setBorderColor(props.showFeedback ? ((ok) ? '#3ff' : '#f3f') : 'black');
        setBorderColor(props.showFeedback ? ((ok) ? globalVars.feedbackMode.borderColor.ok : globalVars.feedbackMode.borderColor.notOk) : 'black');
        props.onChange({mykey: myKey, ok: ok});
    }, [ok]);

    function handleChange(text) {
        setCurrenttext(text.replaceAll('&nbsp;', '').trim());
        // console.log("MyMediumEditor.handleChange(event=" + text + ")")
    }

    // function handleClick(e) {
    //     if (e.ctrlKey) {
    //         e.target.textContent = e.target.title.split("|")[0]
    //         // e.target.fireEvent("onchange");
    //         e.target.onchange();
    //     }
    // }

    function handleMouseDown(e) {
        if (e.ctrlKey && e.altKey) {
            e.target.textContent = expectedtext.split("|").join(" | ")
        }
        if (e.ctrlKey && e.shiftKey) {
            e.target.textContent = ''
        }
        handleChange(e.target.textContent)
    }

    return (
        <>
            <div style={{
                backgroundColor: backgroundColor,
                borderBottom: '1px solid ' + borderColor,
                // backgroundColor: 'yellow',
                // border: '1px solid lightgrey',
                display: "inline-flex",
                margin: '0',
                padding: '0',
                // width: '50px'
            }}
            ><Editor
                tag="span"
                // text="&nbsp;"
                onChange={handleChange}
                // onClick={e => handleClick(e)}
                onMouseDown={e => handleMouseDown(e)}
                // title={expectedtext.split("|").join(" | ")}
                style={{
                    // marginLeft: '-0.1em',
                    display: 'flex',
                    justifyContent: 'left', //left in tables but center in filltext and fillquestion
                    // paddingLeft: '0.3em',
                    // paddingRight: '0.3em',
                    wordWrap: "anywhere",
                    minWidth: Math.min((expectedtext.split("|")[0].length / 2), 7).toString() + 'em'
                }}
                options={{
                    toolbar: false,
                    placeholder: {
                        text: 'Type your text',
                        hideOnClick: true
                    },
                    paste: {
                        forcePlainText: false,
                        cleanPastedHTML: false
                    },
                    disableReturn: true, // https://github.com/yabwe/medium-editor/issues/865
                    disableDoubleReturn: true, // https://github.com/yabwe/medium-editor/issues/865
                }}
            />&nbsp;</div>
        </>
    )
}
